import React, {memo} from 'react';
import {
  GithubFilled,
  FacebookFilled,
  TwitterSquareFilled,
} from '@ant-design/icons';
import IconAddress from './IconAddress';

const customIconDefault = {
  fontSize: 20,
};

const RightAddress = memo(({customIconStyle = customIconDefault}) => {
  return (
    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
      <IconAddress
        link="https://github.com"
        children={<GithubFilled style={customIconStyle} />}
      />
      <IconAddress
        link="https://github.com"
        children={<FacebookFilled style={customIconStyle} />}
      />
      <IconAddress
        link="https://github.com"
        children={<TwitterSquareFilled style={customIconStyle} />}
      />
    </div>
  );
});

export default RightAddress;
